import { SiteLink } from 'interfaces/site-link.interface';

export const items = [
    {
        label: 'Dla użytkownika',
        items: [
            {
                label: 'Regulamin',
                href: '/regulamin',
                title: 'Regulamin użytkownika',
                rel: 'nofollow'
            },
            {
                label: 'O nas',
                href: '/o-nas',
                title: 'O nas',
                rel: 'nofollow'
            }
        ]
    },
    {
        label: 'Cenojad.pl',
        items: [
            {
                label: 'Polityka prywatności',
                href: 'https://polityka-prywatnosci.onet.pl/',
                title: 'Twoje zgody w serwisie cenojad.pl',
                rel: 'nofollow'
            },
            {
                label: 'Zasady sortowania ofert',
                href: '/zasady-sortowania-ofert',
                title: 'Zasady sortowania ofert',
                rel: 'nofollow'
            },
            {
                label: 'Akt o usługach cyfrowych',
                href: '/akt-uslugi-cyfrowe',
                title: 'Akt o usługach cyfrowych',
                rel: 'nofollow'
            },
            {
                label: 'Zgloś kwestię prawną',
                href: '/report-notice/index.html',
                title: 'Zgloś kwestię prawną',
                rel: 'nofollow',
                icon: 'mail',
                weight: '600',
                target: '_blank'
            }
        ]
    }
] as {
    label: string;
    items: SiteLink[];
}[];
